/**
 * Codes d'erreur des mutations « Mon compte » (API `account.service.ts`) et
 * leur libellé (#77). Un code inconnu retombe sur l'échec générique : la liste
 * explique les refus prévus, elle n'énumère pas toutes les pannes.
 */
const ACCOUNT_ERROR_KEYS: Record<string, string> = {
  NAME_REQUIRED: 'account.error.nameRequired',
  NAME_TOO_LONG: 'account.error.nameTooLong',
  IMPERSONATION_READ_ONLY: 'account.error.impersonation',
  CURRENT_PASSWORD_INVALID: 'account.error.currentPassword',
  PASSWORD_TOO_SHORT: 'password.tooShort',
  NO_LOCAL_PASSWORD: 'account.error.noLocalPassword',
}

/** Clé i18n du message à montrer pour une erreur renvoyée par l'API. */
export function accountErrorKey(error: unknown): string {
  const message = error instanceof Error ? error.message : ''
  const code = Object.keys(ACCOUNT_ERROR_KEYS).find(key => message.includes(key))
  return code ? ACCOUNT_ERROR_KEYS[code]! : 'account.error.generic'
}
